import React, { useContext } from "react";
import { isMobile } from "react-device-detect";

import AppContext from "../../../contexts/AppContext";
import TopSideMenu from "./TopSideMenu";
import "../../../assets/sass/components/shared/layout/_bodyWithTopMenu.scss";

const BodyWithTopMenu = (props) => {
    const { children } = props;
    const { authenticated, showTopNavigationInMobile, toggleShowTopNavigationInMobile } = useContext(AppContext);

    const closeSideMenuInMobile = () => {
        if(showTopNavigationInMobile) {
            toggleShowTopNavigationInMobile();
        }
    }

    return (
        <div className={`body-with-topmenu w-100-percent ${props?.styleClass ? props.styleClass : ""}`}>
            <div className="bwtm-inner-wrapper w-100-percent">
                {authenticated && (
                    <>
                        <div
                            className={`${showTopNavigationInMobile ? " left-0 " : ""} bwtm-aside-container`}
                            style={{zIndex: "11"}}
                        >
                            <div className="bwtm-aside-wrapper">
                                <div className="bwtm-aside-inner">
                                    <TopSideMenu />
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div
                    className={`d-flex justify-center w-100-percent`}
                    onClick={closeSideMenuInMobile}
                >
                    <div
                        className={`bwtm-inner mt-2 w-100-percent`}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BodyWithTopMenu
